// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.maintenance.tasks.RentalManagerUserMaintenanceTaskWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerUserMaintenanceTaskListDto } from '../..';

interface ListParams {
  includeComplete?: boolean;
  includeInProgress?: boolean;
  includeNotStarted?: boolean;
  includeWontComplete?: boolean;
}

export const RentalManagerUserMaintenanceTaskWebApiHandler_list_Path = '/api/web/v1/users/maintenance/tasks/list';

/**
 * Get maintenance task list for user
 */
export const RentalManagerUserMaintenanceTaskWebApiHandler_list = (getParams: ListParams, client = getClient()) => {
  return httpFrontEndRequest<ListParams, never, RentalManagerUserMaintenanceTaskListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserMaintenanceTaskWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
